<template>
    <div class="cla-slider">
        <div class="label-container">
            <div class="slider-label" v-if="label">{{ label }}</div>
            <Tooltip :content="tooltip" v-if="tooltip"></Tooltip>
        </div>
        <vue-slider
            :min="minValue"
            :max="maxValue"
            :interval="interval || 1"
            v-model="currentValue"
            @change="onValueChanged"
            ref="innerSlider"
            @drag-end="onDragEnd"
        ></vue-slider>
    </div>
</template>

<script setup>
import { Tooltip } from "clariant-vue3-forms";
import vueSlider from "vue-slider-component";
import { ref, onMounted, watchEffect } from "vue";
import "vue-slider-component/theme/default.css";

const props = defineProps([
    "min",
    "max",
    "label",
    "modelValue",
    "interval",
    "tooltip",
]);
const emit = defineEmits(["update:modelValue", "change"]);
const currentValue = ref(props.modelValue);
const innerSlider = ref(null);
const minValue = ref(0);
const maxValue = ref(100);

onMounted(() => {
    if (!props.modelValue) {
        currentValue.value = [props.min, props.max];
    }
    const sliderDots = document.querySelectorAll(
        ".vue-slider-dot.vue-slider-dot-hover",
    );
    if (sliderDots) {
        sliderDots.forEach((sd) => {
            sd.ariaLabel = "Slider";
        });
    }
});

watchEffect(() => {
    currentValue.value = [...props.modelValue];
    minValue.value = props.min;
    maxValue.value = props.max;
});

function onValueChanged(val) {
    emit("update:modelValue", val);
    //nasty hack for array
    props.modelValue[0] = val[0];
    props.modelValue[1] = val[1];
    emit("change", val);
}

function onDragEnd() {}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.cla-slider {
    margin-bottom: 20px;
}
.cla-slider .label-container {
    display: flex;
    align-items: center;
    margin-bottom: 50px;
}
.cla-slider .slider-label {
    font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
    font-size: 18px;
    font-weight: 500;
}

.cla-slider .tooltip {
    margin-top: 0;
}

.cla-slider .vue-slider-dot-tooltip {
    visibility: visible;
}
</style>
